<template>
  <div>
    <v-flex>
      <v-flex></v-flex>
    </v-flex>
    <div class="header-container" v-if="getMeProfile">
      <div class="logo">
        <img src="../../assets/logo_consultified.png" alt />
        <button type="button" class="toggle-button ripple" v-if="mobile" @click="showMenu=true">
          <span class="mdi mdi-menu"></span>
        </button>
      </div>
      <div class="search-wrapper">
        <input type="text" v-model="search___query" @blur="hideDropDown" />
        <button class="search-button ripple">Search</button>
        <div class="search-body" v-show="isSearchDropdownShown">
          <div
            class="search-body-row"
            v-ripple
            @click="viewUserProfile(result.user_id)"
            v-for="(result,index) in searchResults"
            :key="index"
          >
            <div class="row-body">
              <img
                v-if="result.profile_pic"
                :src="$fullUrl('images/profiles/'+result.profile_pic)"
                alt="Profile picture"
              />
              <img v-else src="../../assets/avatar.png" alt />
              <span>{{result.first_name + " "+ result.last_name | validate }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="overlay" v-if="mobile" v-show="showMenu"></div>
      <div class="menu-wrapper" v-show="showMenu">
        <span class="close-sidebar" @click="showMenu=false">x</span>
        <ul class="menus">
          <router-link tag="li" :to="{name: 'feeds'}" class="menu-item">
            <a>Home</a>
          </router-link>
          <router-link tag="li" :to="{name: 'network'}" class="menu-item">
            <div class="group">
              <span class="badge" v-if="networks > 0 && checkRoute('/network')">{{networks | validate }}</span>
              <a>Network</a>
            </div>
          </router-link>
          <router-link tag="li" :to="{name: 'messages'}" class="menu-item">
            <div class="group">
              <span class="badge" v-if="messages > 0 && checkRoute('/messages')">{{messages | validate }}</span>
              <a>Messages</a>
            </div>
          </router-link>
          <router-link tag="li" :to="{name: 'notifications'}" class="menu-item">
            <div class="group">
              <span
                class="badge"
                v-if="notifications > 0 && checkRoute('/notifications') "
              >{{notifications | validate }}</span>
              <a>Notifications</a>
            </div>
          </router-link>
          <li class="menu-item dropdown">
            <a href @click.prevent.stop="isDropDownShown=!isDropDownShown" class="toggle-dropdown">
              <span class="mdi mdi-menu-down"></span>
              <img
                v-if="getMeProfile.profile_picture"
                :src="$fullUrl(getMeProfile.profile_picture)"
                alt
              />
              <img src="../../assets/avatar.png" v-else alt />
            </a>
            <ul class="sub-menus" v-show="isDropDownShown">
              <li class="item">
                <router-link :to="{name: 'user-profile'}">Profile</router-link>
              </li>
              <li class="item">
                <a href @click.prevent="logOut">Log out</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import searchComponent from "@/components/Search/Main";
export default {
  name: "profile-header",
  components: {
    searchComponent
  },
  mounted() {
    let vm = this;
    vm.screenResize();
    window.addEventListener("click", function() {
      vm.isDropDownShown = false; //To close dropdown menu
    });
    vm.getProfileData();
    vm.$socket.emit("register", this.$store.state.userId);
  },
  data() {
    return {
      showMenu: true,
      isDropDownShown: false,
      profileData: null,
      notifications: 0,
      messages: 0,
      networks: 0,
      notifs: 0,
      isSearchDropdownShown: false,
      search___query: "",
      searchResults: [],
      connections: [],
      onlineUsers: []
    };
  },
  sockets: {
    connect: function() {
      //this.$emit("connecting", this.$store.state.userId)
    },
    notification: function(payload) {
      if (payload.id === this.$store.state.userId) {
        this.notifications = this.notifications + 1;
      }
    },
    message: function(payload) {
      if (payload.id === this.$store.state.userId) {
        this.messages = this.messages + 1;
        console.log(this.messages);
      }
    },
    network: function(payload) {
      if (payload.id === this.$store.state.userId) {
        this.networks = this.networks + 1;
      }
    }
  },
  computed: {
    ...mapGetters(["getMeProfile", "getHelper"]),
    mobile() {
      return this.$mq.below("width", "601px");
    }
  },
  watch: {
    "$mq.resize": "screenResize",
    search___query: function(query) {
      this.search(query);
    },
    searchResults: function(q) {
      if (q.length < 1) this.isSearchDropdownShown = false;
    }
  },
  methods: {
    ...mapActions(["GET_ME_PROFILE_DATA"]),
    screenResize() {
      if (this.$mq.below("width", "601px")) {
        /*xs: < 600px --Mobile phones*/
        this.showMenu = false;
      } else {
        /*md-xl: Laptops ...*/
        this.showMenu = true;
      }
    },
    logOut() {
      // if (window.$cookies.isKey('user')) {
      //     window.$cookies.remove('user');
      //     this.$router.push({name: 'login'});
      // }

      this.$store.dispatch("AUTH_LOGOUT");
      this.$cookies.remove("project-token");
      this.$cookies.remove("employment-token");
    },
    getProfileData() {
      let vm = this;
      vm.$store.dispatch("GET_ME_PROFILE_DATA");
      // vm.$startLoader()
      // vm.$http.get(
      //     vm.$fullUrl(vm.$store.state.api.relativeUrls.getFeedsProfileData),
      //     {
      //         headers: {'Authorization': 'Bearer ' + vm.$store.state.authToken}
      //     }
      // ).then(function (response) {
      //     vm.profileData = response.data
      //     vm.notifications = response.data.notifications
      //     vm.messages = response.data.messages
      //     vm.networks = response.data.invitations
      // }).catch(() => {

      // }).finally(() => {
      //     vm.$stopLoader()
      // })
    },
    checkRoute(route) {
      return this.$router.history.current.fullPath !== route;
    },
    search(query) {
      let vm = this;
      //vm.searchConnection.loader.isLoading = true
      if (query.length > 0) {
        vm.$http
          .post(
            vm.$fullUrl(vm.getHelper.api.relativeUrls.getSearchResults),
            {
              q: query
            },
            {
              headers: {
                Authorization: "Bearer " + sessionStorage.authToken
              }
            }
          )
          .then(function({ data }) {
            vm.searchResults = [];
            console.log(data);
            vm.isSearchDropdownShown = true;
            data.forEach(function($val) {
              vm.searchResults.push($val._source);
            });
          })
          .catch(error => {})
          .finally(() => {
            //vm.searchConnection.loader.isLoading = false
          });
        // }
      } else this.isSearchDropdownShown = false;
    },
    viewUserProfile(id) {
      //window.location.replace(this.$fullUrl('user/profile/'+id))
      this.$router.replace({ name: "connection-profile", params: { id: id } });
    },
    hideDropDown() {
      let vm = this;
      setTimeout(function() {
        vm.isSearchDropdownShown = false;
      }, 100);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/main";

#sera {
  z-index: 0;
}

.header-container {
  display: flex;
  flex-direction: row;
  padding: 0 $pad-sides;
  background-color: white;
  height: 64px;
  align-items: center;
  @media (max-width: 600px) {
    padding: 8px;
    flex-direction: column;
    position: relative;
    height: auto;
  }
  .logo {
    width: 220px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media (max-width: 600px) {
      width: 100%;
      border-bottom: 1px solid $black-1;
    }
    img {
      width: 100%;
      height: 48px;
      @media (max-width: 600px) {
        width: auto;
      }
    }
    .toggle-button {
      background-color: transparent;
      outline: none;
      border: none;
      cursor: pointer;
      padding: 4px 8px;
      /*height: 48px;*/
      display: none;
      @media (max-width: 600px) {
        display: block;
      }
    }
  }
  .search-wrapper {
    display: flex;
    flex-direction: row;
    margin-left: 16px;
    @media (max-width: 600px) {
      margin-left: 0;
      flex-direction: column;
      margin-top: 24px;
      padding-bottom: 16px;
      align-items: center;
    }
    input {
      border-radius: 40px;
      height: 36px;
      border: 1px solid $black-1;
      width: 280px;
      outline: none;
      padding: 0 16px;
    }
    .search-button {
      background-color: $orange;
      height: 32px;
      border: none;
      border-radius: 40px;
      width: 120px;
      color: rgba(255, 255, 255, 0.8);
      margin-left: 16px;
      outline: none;
      &:hover,
      &:active {
        outline: none;
      }
      @media (max-width: 600px) {
        margin-top: 8px;
        margin-left: 0;
      }
    }
    .search-body {
      position: absolute;
      padding: 4px 8px;
      border: 1px solid $black-1;
      z-index: 1;
      min-width: 120px !important;
      background-color: white;
      margin-top: 38px;
      overflow-y: auto;
      .search-body-row {
        width: 260px;
        padding: 10px 20px 10px 20px;
        border-bottom: 1px solid gainsboro;
        .row-body {
          img {
            width: 25px;
            height: 25px;
          }
          span {
            margin-left: 5%;
          }
        }
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
  .overlay {
    display: none;
    @media (max-width: 600px) {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 3;
      overflow-x: hidden;
      box-sizing: border-box;

      background-color: $black-3;
    }
  }
  .menu-wrapper {
    margin-left: 72px;
    @media (max-width: 600px) {
      position: fixed;
      top: 0;
      left: 0;
      margin-left: 0;

      height: 100%;
      width: 300px;
      z-index: 5;
      overflow-x: hidden;
      box-sizing: border-box;

      background-color: $black-7;
    }
    .close-sidebar {
      display: none;
      @media (max-width: 600px) {
        display: block;
        color: white;
        margin: 16px;
        font-size: 1.5em;
      }
    }
    .menus {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: row;
      @media (max-width: 600px) {
        flex-direction: column;
        margin-top: 24px;
      }
      .menu-item {
        margin-left: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @media (max-width: 600px) {
          margin-top: 16px;
        }
        a {
          text-decoration: none;
          color: $black-light;
          @media (max-width: 600px) {
            color: white;
          }
          &:hover {
            color: $orange;
          }
        }
        .group {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          span {
            margin-right: 1px;
            margin-top: -16px;
            background-color: $orange;
            /*padding: 8px;*/
            width: 16px;
            height: 16px;
            border-radius: 50%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 10px;
          }
        }
        &.router-link-active {
          a {
            color: $orange;
          }
          &:after {
            content: "";
            height: 2px;
            width: 100%;
            background-color: $orange;
            @media (max-width: 600px) {
              height: 0;
            }
          }
        }
        &.dropdown {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          .toggle-dropdown {
            display: flex;
            flex-direction: row;
            align-items: center;
            img {
              width: 32px;
              height: 32px;
              border-radius: 50%;
              display: block;
            }
            span {
              padding: 0;
              font-size: 24px;
            }
          }
          .sub-menus {
            /*display: none;*/
            position: absolute;
            top: 100%;
            left: 0;
            background-color: white;
            border: 1px solid $grey;
            border-radius: 4px;

            list-style: none;
            padding: 0;
            z-index: 100;
            min-width: 100px;
            .item {
              padding: 0;
              white-space: nowrap;
              margin: 8px 8px 0 8px;
              &:last-child {
                margin-bottom: 8px;
              }
              a {
                display: block;
                padding: 0 16px;
                color: $black-light;
                &:hover {
                  color: $orange;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>